import React from 'react';
import s from './adGod.scss';
import {  PromotionInstance } from '../../models/apis/promotion';
import { FeedInstance } from '../../models/feed';
import { GodBox } from './GodBox';
import { SubjectPlaceHolderConfig, SubjectPlaceHolder } from '../SubjectPlaceHolder';
import { isXPSAdInstance } from '../../models/apis/batchCisApi';
interface Props {
    // dataSource: CisItem[],
    dataSource: Array<FeedInstance | PromotionInstance>,
    placeholderConfigs: SubjectPlaceHolderConfig[],
}

export const SliderAds = (props: Props) => {
    const { dataSource, placeholderConfigs } = props;
    return (
        <div className={s.sliderContainer} data-asm-new-slider="true" data-spm="god-side-2">
            <div className='slider-wrapper'>
                {
                    placeholderConfigs.map((placeholder, index) => {
                        const ad = dataSource[index];
                        if (isXPSAdInstance(ad)) {
                            return (
                                <div className='slider-item' key={index}>
                                    <GodBox width={300} height={250} dataSource={[ad]}>
                                        <SubjectPlaceHolder {...placeholder} />
                                    </GodBox>
                                </div>
                            );
                        }
                        return (
                            <div className='slider-item' key={index}>
                                <div className="god-box" style={{ height: 250, width: 300 }}>
                                    <SubjectPlaceHolder {...placeholder} />
                                </div>
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/AdGod/SliderAds.tsx